import {
	QUERY_PARAM_SORT_BY,
	QUERY_PARAM_SORT_ORDER,
} from '@atlassian/jira-software-releases-version-detail-issue-list-query-param-controller/src/controllers/filter-sorting-query-param/constants.tsx';
import { useFilterSortingQueryParams } from '@atlassian/jira-software-releases-version-detail-issue-list-query-param-controller/src/controllers/filter-sorting-query-param/index.tsx';
import messages from './messages';
import type { SortByFieldOption, SortOrderOption } from './types';

export const sortOrderOptions: SortOrderOption[] = [
	{ id: 'ASC', label: messages.ascending },
	{ id: 'DESC', label: messages.descending },
];

export const sortByFieldOptions: SortByFieldOption[] = [
	{ id: 'CREATED', label: messages.sortByDateCreated },
	{ id: 'ASSIGNEE', label: messages.sortByAssignee },
	{ id: 'KEY', label: messages.sortByIssueKey },
	{ id: 'PRIORITY', label: messages.sortByPriority },
	{ id: 'STATUS', label: messages.sortByIssueStatusCategory },
	{ id: 'TYPE', label: messages.sortByIssueType },
];

export const useCurrentSortOptions = () => {
	const { parsedQueryParams } = useFilterSortingQueryParams();

	const currentSortByOption =
		sortByFieldOptions.find((option) => option.id === parsedQueryParams[QUERY_PARAM_SORT_BY]) ??
		sortByFieldOptions[0];
	const currentSortOrderOption =
		sortOrderOptions.find((option) => option.id === parsedQueryParams[QUERY_PARAM_SORT_ORDER]) ??
		sortOrderOptions[0];

	return {
		currentSortByOption,
		currentSortOrderOption,
	};
};
